export const ProductReceiveChannels = {
    1: 'RECEIVE_CHANNEL_ABROAD',
    2: 'RECEIVE_CHANNEL_LOCAL',
    3: 'RECEIVE_CHANNEL_SELF_MADE',
    4: 'OTHER'
}